import ContentLoader from 'react-content-loader'
import stylesCard from './Card.module.scss';
import stylesSceleton from './Sceleton.module.scss';


type Props = {
  article_id: string
}


export const Skeleton: React.FC<Props> = ({ article_id }) => {

  const resolution = window.screen.availWidth;

  return (
    <article className={stylesCard.Card}>
      {resolution > 812
        ? <ContentOver812px />
        : <ContentUnder812px />
      }
    </article>
  )
}


function ContentOver812px() {
  return (
    <ContentLoader
      speed={2.5}
      width={778}
      height={210}
      viewBox="0 0 778 210"
      backgroundColor="#c2c2c2"
      foregroundColor="#ecebeb"
    >
      <rect x="37" y="85" rx="10" ry="10" width="40" height="40" />
      <rect x="110" y="2" rx="4" ry="4" width="280" height="206" />
      <rect x="425" y="55" rx="4" ry="4" width="250" height="17" />
      <rect x="425" y="78" rx="4" ry="4" width="80" height="15" />
      <rect x="425" y="96" rx="4" ry="4" width="70" height="15" />
      <rect x="425" y="117" rx="4" ry="4" width="70" height="15" />
      <rect x="425" y="138" rx="4" ry="4" width="100" height="17" />
    </ContentLoader>
  )
}

function ContentUnder812px() {
  return (
    <div className={stylesSceleton.placeholderUnder700}></div>
  )
}

